import React, { PureComponent, Fragment } from 'react';

import PackageJSON from '../../../../package.json';

export default class AppVersion extends PureComponent {
  render() {
    const appVersion = PackageJSON.version || 0;

    return (
      <Fragment>
        {'Version:'} {appVersion}
      </Fragment>
    );
  }
}
